import { AntSpin } from './styles'

export default AntSpin